import React, { useState, useEffect } from "react";
import { SearchOutlined, FilterOutlined } from "@ant-design/icons";
import { Button, Space, InputNumber } from "antd";

const NumberFilter = (item, search) => {
  const Filter = ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
    const [number, setNumber] = useState();
    const [minNum, setMinNum] = useState();
    const [maxNum, setMaxNum] = useState();
    useEffect(() => {
      if (selectedKeys.length === 1) {
        setNumber(selectedKeys[0]);
      } else if (selectedKeys.length === 2) {
        setMinNum(selectedKeys[0]);
        setMaxNum(selectedKeys[1]);
      } else {
        setNumber();
        setMinNum();
        setMaxNum();
      }
    }, [selectedKeys]);

    const handleSearch = () => {
      let searchParams = [];
      let column_type = 1
      if (number) {
        searchParams = [number];
      } else if (minNum || maxNum) {
        column_type = 3
        searchParams = [minNum, maxNum];
      }
      setSelectedKeys(searchParams);
      search({
        column_text: item.title,
        type: 'number',
        column_name: item.dataIndex,
        values: searchParams,
        column_type
      })
      confirm();
    };
    const handleReset = (clearFilters) => {
      clearFilters();
    };
    return (
      <div
        style={{
          padding: 8,
        }}
      // onKeyDown={(e) => e.stopPropagation()}
      >
        <InputNumber
          placeholder="请输入检索数值"
          value={number}
          onChange={(value) => {
            setNumber(value);
            setMinNum();
            setMaxNum();
          }}
          style={{
            marginBottom: 8,
            width: "202px",
            display: "block",
          }}
        />
        <div
          style={{
            marginBottom: 8,
          }}
        >
          <Space>
            <InputNumber
              placeholder="最小值"
              value={minNum}
              onChange={(value) => {
                setNumber();
                setMinNum(value);
              }}
            />
            -
            <InputNumber
              placeholder="最大值"
              value={maxNum}
              onChange={(value) => {
                setNumber();
                setMaxNum(value);
              }}
            />
          </Space>
        </div>

        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch()}
            icon={<SearchOutlined />}
            style={{
              width: 90,
            }}
          >
            搜索
          </Button>
          <span style={{ visibility: "hidden" }}>-</span>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            style={{
              width: 90,
            }}
          >
            清空
          </Button>
        </Space>
      </div>
    );
  };

  return {
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys = [],
      confirm,
      clearFilters,
    }) => (
      <Filter
        setSelectedKeys={setSelectedKeys}
        selectedKeys={selectedKeys}
        confirm={confirm}
        clearFilters={clearFilters}
      />
    ),
    filterIcon: (filtered) => (
      <FilterOutlined
        style={{
          color: filtered ? "#1890ff" : undefined,
        }}
      />
    ),
  };
};
export default NumberFilter;
